// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-dashboard_dashboard-empty__aDOeN {
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-dashboard_icon-pending__B\\+GKN {
  color: var(--white-text-color);
  stroke-width: 1.5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/empty-state/dashboard/empty/empty-dashboard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":[".dashboard-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-pending {\n  color: var(--white-text-color);\n  stroke-width: 1.5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard-empty": `empty-dashboard_dashboard-empty__aDOeN`,
	"icon-pending": `empty-dashboard_icon-pending__B+GKN`
};
export default ___CSS_LOADER_EXPORT___;
